import React from "react";
import { Outlet } from "react-router-dom";
import SiteHeader from "../Topbar/SiteHeader";
import SiteNavbar from "../SiteNavbar";

const SiteLayout = () => {
  return (
    <div className="">
      <SiteHeader />
      <div className="dashboard">
        <SiteNavbar />
        <Outlet />
      </div>
    </div>
  );
};

export default SiteLayout;
